<button type="button" class="btn btn-{{class}}"
  placement="left" container="body" [ngbTooltip]="'log.activity-log-tooltip'|translate"
  (click)="click(); $event.stopPropagation()"><i class="fas fa-history"></i></button>